import { AdminTitle } from "@/admin/AdminTitle.tsx";
import { googleTagManagerQueryAtom } from "@/admin/marketing/googleTagManagerQuery.ts";
import { UpdateGoogleTagManagerKeyModal } from "@/admin/marketing/UpdateGoogleTagManagerKeyModal.tsx";
import { WAdminTable } from "@/admin/WAdminTable.tsx";
import { EditableButton } from "@/components/forms/EditableButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { WTableBody } from "@/components/table/WTable.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";

export function TrackingView() {
    const gtm_key = useSuspenseQueryAtom(googleTagManagerQueryAtom);

    return (
        <>
            <AdminTitle title="Tracking Codes" />

            <WAdminTable>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Description</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <WTableBody>
                    <tr>
                        <td>Google Tag Manager key</td>
                        <td>
                            Add or edit your Google Tag Manager key to enable platform tracking. (Key format:
                            GTM-xxxxxxx)
                        </td>
                        <td>
                            <WModal button={<EditableButton action={undefined}>{gtm_key?.gtm_key}</EditableButton>}>
                                <UpdateGoogleTagManagerKeyModal value={gtm_key?.gtm_key} />
                            </WModal>
                        </td>
                    </tr>
                </WTableBody>
            </WAdminTable>
        </>
    );
}
